import React, { Component } from 'react'
import findIndex from 'lodash.findindex'
import { Link } from 'react-router'
import Mission from './Mission'
import RaisedButton from 'material-ui/RaisedButton'
import Team from './Team'
import teamConfig from '../../configs/team-config'

class About extends Component {
  constructor(props) {
    super(props)
    let selectedIndex, protegeIndex
    if (this.props.params.value) {
      const name = this.props.params.value.replace(/-/g," ")
      selectedIndex = findIndex(teamConfig, (t)=>{
        return t.name.toLowerCase() === name
      })
    }

    this.state = {
      missonExpanded: false,
      selectedIndex: selectedIndex,
      protegeIndex: protegeIndex
    }
    this._toggleMission = this._toggleMission.bind(this)
    this._toggleTeamMate = this._toggleTeamMate.bind(this)
    this._toggleProtege = this._toggleProtege.bind(this)
  }

  _toggleMission(){
    this.setState({missionExpanded: !this.state.missionExpanded})
  }

  _toggleTeamMate(id){
    id === this.state.selectedIndex ?
      this.setState({ selectedIndex: null })
    :
      this.setState({ selectedIndex: id })
  }

  _toggleProtege(id){
    id === this.state.protegeIndex ?
      this.setState({ protegeIndex: null })
    :
      this.setState({ protegeIndex: id })
  }

  render (){
    const { browser } = this.props
    const { missionExpanded, selectedIndex, protegeIndex } = this.state
    let columnCount = browser.mediaType === 'extraSmall' ? 2 : 6

    return (
      <div className="about-page">
        <Mission
          clickHandler={this._toggleMission} 
          missionToggled={missionExpanded}
        />
        <Team
          columnCount={columnCount}
          clickHandler={this._toggleTeamMate}
          selectedIndex={selectedIndex}
          protegeIndex={protegeIndex}
          protegeHandler={this._toggleProtege}
        />
        <div className="join-the-team">
          <h1>JOIN OUR TEAM</h1>
          <p>We’re building a one-of-a-kind, open-source curriculum with virtual content and collaborative hardware building modules. Our team is diverse, building content that ties together neuroscience, robotics, anatomy, data visualization, system networking and philosophy. Join our team!</p>
          <Link to="/get-involved">
            <RaisedButton
              style={{ marginTop: '25px', minWidth: '200px'}}
              label="View Volunteer Opportunities"
              className="mm-button"
            />
          </Link>
        </div>
      </div>
    )
  }
} 

export default About


// WEBPACK FOOTER //
// ./src/components/About/About.js